'use strict';
var userAgent = require('../internals/environment-user-agent');

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-webkit-version.js
// module id = 216
// module chunks = 0